<template>
    <div class="main-box">
        <router-view></router-view>
        <div class="footer">
			<div class="course-menu-box">
				<router-link to="/teacher/course/schedule">课程表1</router-link>
                <router-link to="/teacher/course/list">我的课程</router-link>
			</div>
            <span class="footer-course" @click="footBtn($event,0)">课程</span>
            <router-link to="/teacher/msg/list"><span class="footer-msg" @click="footBtn($event,1)">消息</span></router-link>
            <router-link to="/teacher/user/center"><span class="footer-center" @click="footBtn($event,2)">我的</span></router-link>
        </div>
    </div>
</template>

<script>
	export default{
		data(){
			return{
				msgCount:0
			}
		},
		methods:{
			footBtn:function(event,type){
				var index = $(event.currentTarget).index();
				$('.footer .on').removeClass('on')
				$(event.currentTarget).addClass("on");
				var $menu = $('.course-menu-box');
				if(type == 0){
					if($menu.hasClass('active')){
						$menu.removeClass('active');
						var path = this.$route.fullPath;
						this.resetMenu();
					}else{
						$menu.addClass('active');
					}
				}else{
					$menu.removeClass('active');
				}
			},
			focusMenu : function(to, from){
				$('.course-menu-box').removeClass('active');
			},
			resetMenu : function(){
				$('.footer .on').removeClass('on')
				var path = this.$route.path;
				var $this = null;
				if(path.indexOf('/course') > -1){
					$this = $('.footer-course');
				}
				if(path.indexOf('/msg') > -1){
					$this = $('.footer-msg');
				}
				if(path.indexOf('/user') > -1){
					$this = $('.footer-center');
				}
				$this.addClass("on").siblings().find(".on").removeClass("on");
			}
		},
		watch: {
		   // 如果路由有变化，会再次执行该方法
		   '$route': 'focusMenu'
		},
		mounted(){
		   	this.resetMenu();
		},
		beforeDestroy(){
		},
		destroyed(){
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/teacherCommon.css" ></style>
<style scoped>
/* @import url('../../../static/css/teacherCommon.css'); */

.footer{
    position: fixed;
    left: 0;
    bottom: 0;
    height: .96rem;
    text-align: center;
    font-size: .2rem;
    width: 100%;
    box-sizing: border-box;
    background:rgba(255,255,255,0.5);
    box-shadow:0rem -0.02rem 0.06rem 0rem rgba(0,0,0,0.05);
    border-top: none;
    z-index: 50;
    background: #fff;
}
.footer span{
    width: 33.33%;
    text-align: center;
    display: inline-block;
    background-image: url("../../../static/images/ico_mes@2x.png");
    background-size: .4rem .38rem;
    background-position: center .12rem;
    background-repeat: no-repeat;
    padding-top: .6rem;
    box-sizing: border-box;
    height: .96rem;
    color: #666666;
	font-size:0.2rem;
    line-height: 1;
}

.footer span.on{
    color: #03bbb5;
}
.footer span.footer-course{
    float: left;
    background-image: url("../../../static/images/teacher/footer_course.png");
    background-size: .4rem .4rem;
}

.footer span.footer-center{
    float: right;
    background-image: url("../../../static/images/teacher/footer_mine.png");

    background-size: .36rem .4rem;
}

.footer span.footer-course.on{
    background-image: url("../../../static/images/teacher/footer_course_on.png");
}

.footer span.footer-msg.on{
    background-image: url("../../../static/images/teacher/footer_msg_on.png");
}

.footer span.footer-center.on{
    background-image: url("../../../static/images/teacher/footer_mine_on.png");
}



h1, h2 {
  font-weight: normal;
}
.footer .footer-course,.footer .footer-msg{
    position: relative;
	background-image: url("../../../static/images/teacher/footer_msg.png");
	background-size: .4rem .4rem;
}
.footer .footer-course::after,.footer .footer-msg::after{
    content: '';
    position: absolute;
    width: .02rem;
    height: 0.62rem;
    background: #F1F1F1;
    top: .15rem;
    right: 0;
}
.footer .course-menu-box{
	position: absolute;
	bottom: .99rem;
	left: 0;
	background-color: #fff;
	border: .01rem solid #ccc;
	display: none;
	width: 2.5rem;
	box-sizing: border-box;
	padding: 0 .19rem;
	border-radius: .05rem;
}

.footer .course-menu-box.active{
	display: block;
}

.footer .course-menu-box a{
	line-height: 1rem;
	display: block;
	width: 100%;
	font-size: .28rem;
	color: #b8bacc;
	text-align: center;
	
}
.footer .course-menu-box a:first-child{
	border-bottom: .01rem solid #ccc;
}
.footer-border-right{

}
</style>



// WEBPACK FOOTER //
// src/components/teacher/footer.vue